import moment from 'moment';
import _ from 'lodash';

export function imprimirCasoViolencia(caso) {
  //Esta funcion recibe un HTML por parametro y crea el documento necesario para imprimir.

  var mywindow = window.open('', 'PRINT', 'height=400,width=600');
  mywindow.document.write('<html><head><title></title>');
  // mywindow.document.write("<style> footer {font-size: 9px;color: #f00;text-align: center;}@page {size: A4;margin: 11mm 17mm 17mm 17mm;}@media print {footer {position: fixed;bottom: 0;}.content-block, p {page-break-inside: avoid;} html, body {width: 210mm;height: 297mm;}} </style>");
  mywindow.document.write(
    "<style> @media screen { header.onlyprint, footer.onlyprint{ display: none; /* Hide from screen */ } } @media print { header.onlyprint { position: fixed; /* Display only on print page (each) */ top: 0; /* Because it's header */ } footer.onlyprint { position: fixed; bottom: 0; /* Because it's footer */ }  } </style>"
  );
  mywindow.document.write('</head><body >');
  // mywindow.document.write('<header class="onlyprint">Contenido del Header</header>');
  mywindow.document.write('<div class="textoAImprimir">');

  mywindow.document.write(``);
  mywindow.document.write(
    `<h2 style="text-align: center"><ins> CASO DE VIOLENCIA</ins></h3>`
  );
  mywindow.document.write(
    `<h3 style="margin-top: 30px"> Organismo: ${caso.organismo.nombre}  </h3>`
  );

  mywindow.document.write(
    `<h4> Fecha de creación del caso: ${moment(caso.fecha).format(
      'DD/MM/YYYY'
    )} </h4>`
  );

  mywindow.document.write(
    `<h5> Fecha de generacion del reporte: ${moment().format(
      'DD/MM/YYYY'
    )} </h5>`
  );

  mywindow.document.write(`<div class="divImprimirPersona>`);

  mywindow.document.write(`<hr/>`);

  mywindow.document.write(
    `<div class="ant-card-head-title">DENUNCIANTE: ${caso.denunciante.nombre} ${
      caso.denunciante.apellido
    }</div>`
  );

  mywindow.document.write(
    `<p> 
      <b>Documento: </b> ${caso.denunciante.tipo_doc} ${
      caso.denunciante.num_doc
    } <br/>
      <b>Sexo: </b> ${caso.denunciante.sexo}<br/>
      <b>Fecha Nacimiento: </b> ${moment(
        caso.denunciante.fecha_nacimiento
      ).format('DD/MM/YYYY')}<br/>
      <b>Edad: </b> ${caso.denunciante.edad}<br/>
      <b>Telefono: </b> ${
        caso.denunciante.telefono ? caso.denunciante.telefono : '-'
      }<br/>
      <b>Nacionalidad: </b> ${
        caso.denunciante.nacionalidad ? caso.denunciante.nacionalidad : '-'
      }<br/>
      <b>Educacion: </b> ${
        caso.denunciante.educacion ? caso.denunciante.educacion : '-'
      }<br/>
      <b>Profesion: </b> ${
        caso.denunciante.profesion ? caso.denunciante.profesion : '-'
      }<br/>
      <b>Localidad: </b> ${
        caso.denunciante.localidad ? caso.denunciante.localidad.nombre : '-'
      }<br/>
      <b>Direccion: </b> ${
        caso.denunciante.direccion_calle
          ? caso.denunciante.direccion_calle
          : '-'
      }  ${
      caso.denunciante.direccion_numero
        ? caso.denunciante.direccion_numero
        : '-'
    } ${
      caso.denunciante.direccion_otro ? caso.denunciante.direccion_otro : ''
    }<br/>
    </p>`
  );
  mywindow.document.write(`</div>`);

  mywindow.document.write(
    `<div class="ant-card-head-title">VICTIMA: ${caso.victima.nombre} ${
      caso.victima.apellido
    }</div>`
  );

  mywindow.document.write(
    `<p> 
      <b>Documento: </b> ${
        caso.victima.tipo_doc && caso.victima.num_doc
          ? caso.victima.tipo_doc + ' ' + caso.victima.num_doc
          : '-'
      }  <br/>
      <b>Sexo: </b> ${caso.victima.sexo ? caso.victima.sexo : '-'}<br/>
      <b>Fecha Nacimiento: </b> ${
        caso.victima.fecha_nacimiento
          ? moment(caso.victima.fecha_nacimiento).format('DD/MM/YYYY')
          : '-'
      }<br/>
      <b>Edad: </b> ${caso.victima.edad ? caso.victima.edad : '-'}<br/>
      <b>Telefono: </b> ${
        caso.victima.telefono ? caso.victima.telefono : '-'
      }<br/>
      <b>Nacionalidad: </b> ${
        caso.victima.nacionalidad ? caso.victima.nacionalidad : '-'
      }<br/>
      <b>Educacion: </b> ${
        caso.victima.educacion ? caso.victima.educacion : '-'
      }<br/>
      <b>Profesion: </b> ${
        caso.victima.profesion ? caso.victima.profesion : '-'
      }<br/>
      <b>Localidad: </b> ${
        caso.victima.localidad ? caso.victima.localidad.nombre : '-'
      }<br/>
      <b>Direccion: </b> ${
        caso.victima.direccion_calle ? caso.victima.direccion_calle : '-'
      }  ${
      caso.victima.direccion_numero ? caso.victima.direccion_numero : '-'
    } ${caso.victima.direccion_otro ? caso.victima.direccion_otro : ''}<br/>
    </p>`
  );
  mywindow.document.write(`</div>`);

  _.forEach(caso.agresores, agresor => {
    mywindow.document.write(
      `<div class="ant-card-head-title">AGRESOR: ${agresor.nombre} ${
        agresor.apellido
      }</div>`
    );

    mywindow.document.write(
      `<p> 
        <b>Documento: </b> ${
          agresor.tipo_doc && agresor.num_doc
            ? agresor.tipo_doc + ' ' + agresor.num_doc
            : '-'
        } <br/>
        <b>Sexo: </b> ${agresor.sexo ? agresor.sexo : '-'}<br/>
        <b>Fecha Nacimiento: </b> ${
          agresor.fecha_nacimiento
            ? moment(agresor.fecha_nacimiento).format('DD/MM/YYYY')
            : '-'
        }<br/>
        <b>Edad: </b> ${agresor.edad ? agresor.edad : '-'}<br/>
        <b>Telefono: </b> ${agresor.telefono ? agresor.telefono : '-'}<br/>
        <b>Nacionalidad: </b> ${
          agresor.nacionalidad ? agresor.nacionalidad : '-'
        }<br/>
        <b>Educacion: </b> ${agresor.educacion ? agresor.educacion : '-'}<br/>
        <b>Profesion: </b> ${agresor.profesion ? agresor.profesion : '-'}<br/>
        <b>Localidad: </b> ${
          agresor.localidad ? agresor.localidad.nombre : '-'
        }<br/>
        <b>Direccion: </b> ${
          agresor.direccion_calle ? agresor.direccion_calle : '-'
        }  ${agresor.direccion_numero ? agresor.direccion_numero : '-'} ${
        agresor.direccion_otro ? agresor.direccion_otro : ''
      }<br/>
      </p>`
    );
    mywindow.document.write(`</div>`);
  });
  if (caso.evaluacion) {
    mywindow.document.write(`<h3 style="margin-top: 30px"> Evaluación: </h3>`);
    mywindow.document.write(`
  <table style="width:100% ">
  <tr style="text-align:left">
    <th>Indicador</th>
    <th>Respuesta</th> 
  </tr>
  `);

    mywindow.document.write(generarFila('CLASE DE VIOLENCIA', ''));
    mywindow.document.write(
      generarFila('Violencia fisica', caso.evaluacion.violenciaFisica)
    );
    mywindow.document.write(
      generarFila(
        'Agresión verbal/psico/emocional',
        caso.evaluacion.violenciaEconomica
      )
    );
    mywindow.document.write(
      generarFila(
        'Violencia sexual/reproductiva',
        caso.evaluacion.violenciaSexual
      )
    );
    mywindow.document.write(
      generarFila(
        'Violencia economica/patrimonial',
        caso.evaluacion.violenciaEconomica
      )
    );
    mywindow.document.write(
      generarFila(
        'Violencia restricción participación social',
        caso.evaluacion.restriccionSocial
      )
    );
    mywindow.document.write(
      generarFila('Violencia ambiental', caso.evaluacion.violenciaAmbiental)
    );
    mywindow.document.write(
      generarFila('Violencia simbólica', caso.evaluacion.violenciaSimbolica)
    );

    mywindow.document.write(generarFila('', ''));

    mywindow.document.write(generarFila('RED SOCIAL Y COMUNITARIA', ''));
    mywindow.document.write(
      generarFila(
        'Parientes a quien recurrir',
        caso.evaluacion.parientes ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Otros a quien recurrir',
        caso.evaluacion.amigos ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Participa en instituciones',
        caso.evaluacion.participaInstituciones ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Conflictos armados',
        caso.evaluacion.conflictosArmados ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Privación de libertad',
        caso.evaluacion.privacionLibertad ? 'SI' : 'NO'
      )
    );

    mywindow.document.write(generarFila(' ', ' '));

    mywindow.document.write(generarFila('ANTECEDENTES DE LA VIOLENCIA', ''));
    mywindow.document.write(
      generarFila(
        'Antecedente de violencia fisica/psicologica en victima',
        caso.evaluacion.antecedenteViolenciaFisicaVictima ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Antecedente de violación/abuso sexual en victima',
        caso.evaluacion.antecedenteViolacionVictima ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Antecedente testigo de violencia en victima',
        caso.evaluacion.antecedenteTestigoVictima ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Antecedente de abandono en victima',
        caso.evaluacion.antecedenteAbandonoVictima ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Antecedente de violencia en otras parejas de la victima',
        caso.evaluacion.antecedenteViolenciaParejasPreviasVictima ? 'SI' : 'NO'
      )
    );

    mywindow.document.write(
      generarFila(
        'Antecedente de violencia fisica/psicologica en agresor',
        caso.evaluacion.antecedenteViolenciaFisicaAgresor ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Antecedente de violación/abuso sexual en agresor',
        caso.evaluacion.antecedenteViolacionAgresor ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Antecedente testigo de violencia en agresor',
        caso.evaluacion.antecedenteTestigoAgresor ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Antecedente de abandono en agresor',
        caso.evaluacion.antecedenteAbandonoAgresor ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Antecedente de violencia en otras parejas del agresor',
        caso.evaluacion.antecedenteViolenciaParejasPreviasAgresor ? 'SI' : 'NO'
      )
    );

    mywindow.document.write(generarFila(' ', ' '));

    mywindow.document.write(
      generarFila('EFECTOS ACTUALES DE LA VIOLENCIA', '')
    );
    mywindow.document.write(
      generarFila(
        'Dificultades/pérdida de estudio',
        caso.evaluacion.dificultadesEstudio ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Maltrato extendido al grupo familiar',
        caso.evaluacion.maltratoExtendido ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Problemas laborales a causa de la violencia',
        caso.evaluacion.problemasLaborales ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Limitación para buscar empleo a causa de la violencia',
        caso.evaluacion.limitacionBusquedaEmpleo ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Perdió empleo por violencia',
        caso.evaluacion.perdioEmpleo ? 'SI' : 'NO'
      )
    );

    mywindow.document.write(generarFila(' ', ' '));

    mywindow.document.write(
      generarFila('INDICADORES DE RIESGO FISICO/ESTADO DE SALUD', '')
    );
    mywindow.document.write(
      generarFila(
        'Signos de agresíon',
        caso.evaluacion.signosAgresion ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Intervencion médica',
        caso.evaluacion.intervencionMedica ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Amenaza de muerte',
        caso.evaluacion.amenazaMuerte ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Presencia armas blancas o de fuego',
        caso.evaluacion.presenciaArmas ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Aborto provocado por agresor',
        caso.evaluacion.abortoProvocado ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Intentos de suicidio',
        caso.evaluacion.intentosSuicidio ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila('Discapacidad', caso.evaluacion.discapacidad ? 'SI' : 'NO')
    );

    mywindow.document.write(generarFila(' ', ' '));

    mywindow.document.write(generarFila('ESTADO DE SALUD', ''));
    mywindow.document.write(
      generarFila(
        'Trastornos de sueño',
        caso.evaluacion.transtornoSuenio ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Trastornos de alimentación',
        caso.evaluacion.transtornoAlimentacion ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Trastornos digestivos',
        caso.evaluacion.transtornosDigestivos ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Ingesta de ansioliticos/antidepresivos',
        caso.evaluacion.ingestaCalmantes ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Consumo de alcohol',
        caso.evaluacion.consumoAlcohol ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Consumo de drogas',
        caso.evaluacion.consumoDrogas ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Enfermedades infectocontagiosas',
        caso.evaluacion.enfermedadesInfectocontagiosas ? 'SI' : 'NO'
      )
    );

    mywindow.document.write(generarFila(' ', ' '));

    mywindow.document.write(
      generarFila('HECHOS QUE ASOCIA A LOS EPISODIOS DE VIOLENCIA', '')
    );
    mywindow.document.write(
      generarFila(
        'Embarazo/nacimiento de hijos',
        caso.evaluacion.provocaHijos ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Alcohol/sustancias psicoadictivas',
        caso.evaluacion.provocaAdiccion ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Autonomia de la victima',
        caso.evaluacion.provocaAutonomia ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'No percibe factores asociados',
        caso.evaluacion.percibeHechos ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Jugador compulsivo',
        caso.evaluacion.provocaJugadorCompulsivo ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila('Celos', caso.evaluacion.provocaCelos ? 'SI' : 'NO')
    );
    mywindow.document.write(
      generarFila(
        'Problemas laborales',
        caso.evaluacion.provocaProblemasLaborales ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Impredecible/confuso',
        caso.evaluacion.hechosImpredeciblesOConfusos ? 'SI' : 'NO'
      )
    );

    mywindow.document.write(generarFila(' ', ' '));

    mywindow.document.write(generarFila('DENUNCIAS ANTERIORES', ''));
    mywindow.document.write(
      generarFila(
        'Denuncia penal/ministerio publico reciente',
        caso.evaluacion.denunciaPenalReciente ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Denuncia civil reciente',
        caso.evaluacion.denunciaCivilReciente ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Antecedentes de intervencion policial reciente',
        caso.evaluacion.intervencionPolicialReciente ? 'SI' : 'NO'
      )
    );

    mywindow.document.write(generarFila(' ', ' '));

    mywindow.document.write(generarFila('DESENCADENANTES DE LA CONSULTA', ''));
    mywindow.document.write(
      generarFila(
        'Hijos grandes/independientes',
        caso.evaluacion.hijosGrandes ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Golpes a los hijos',
        caso.evaluacion.golpesHijos ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Conocimiento del problema en otros/as',
        caso.evaluacion.conocimientoEnOtros ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Adulterio/infidelidad',
        caso.evaluacion.adulterioInfidelidad ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Por solicitud de un hijo',
        caso.evaluacion.porSolicitudDeHijo ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Se siente en una situacion limite',
        caso.evaluacion.seSienteEnSituacionLimite ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Tuvo miedo (mas que el habitual)',
        caso.evaluacion.tuvoMiedo ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Razones legales/juridicas',
        caso.evaluacion.razonesLegalesOJuridicas ? 'SI' : 'NO'
      )
    );
    mywindow.document.write(
      generarFila(
        'Por decisíon de otro',
        caso.evaluacion.porDecisionDeOtro ? 'SI' : 'NO'
      )
    );

    mywindow.document.write(`</table>`);

    mywindow.document.write(`<div>`);

    mywindow.document.write(
      `<h3> RIESGO DE LA EVALUACION: ${obtenerValoracion(
        caso.evaluacion.valor
      )} </h3> `
    );

    mywindow.document.write(`</div>`);
  }

  mywindow.document.write('</div>');
  // mywindow.document.write('<footer class="onlyprint"> Direccion General de Informatica </footer>');
  mywindow.document.write('</body></html>');
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10
  mywindow.print();
  mywindow.close();
}

function generarFila(texto, variable) {
  var temp = ``;

  temp = `<tr style="text-align:left"> <td> ${texto} </td> <td> ${variable} </td> </tr>`;

  return temp;
}

function obtenerValoracion(valor) {
  let riesgo = 'SIN RIESGO';
  if (valor >= 5 && valor < 15) {
    riesgo = 'BAJO';
  }
  if (valor >= 15 && valor < 25) {
    riesgo = 'MODERADO';
  }
  if (valor >= 25 && valor < 30) {
    riesgo = 'MEDIO';
  }
  if (valor >= 30 && valor < 40) {
    riesgo = 'ALTO';
  }
  if (valor >= 40) {
    riesgo = 'ALTISIMO';
  }
  return riesgo;
}
